var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGitHub = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 525 512",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M259.4,16c-137.7,0-243,104.5-243,242.2c0,110.1,69.3,204.3,168.2,237.4c12.7,2.3,17.2-5.6,17.2-12c0-6.2-0.3-40.1-0.3-60.9 c0,0-69.5,14.9-84.1-29.6c0,0-11.3-28.9-27.6-36.3c0,0-22.7-15.6,1.6-15.3c0,0,24.7,2,38.3,25.6c21.7,38.3,58.2,27.3,72.4,20.7 c2.3-15.9,8.7-26.9,15.9-33.4c-55.5-6.2-111.5-14.2-111.5-109.7c0-27.3,7.5-41,23.4-58.5c-2.6-6.5-11-33.1,2.6-67.4 c20.7-6.5,68.5,26.8,68.5,26.8c19.9-5.6,41.2-8.4,62.3-8.4c21.1,0,42.5,2.9,62.3,8.4c0,0,47.7-33.3,68.5-26.8 c13.6,34.4,5.2,60.9,2.6,67.4c15.9,17.6,25.6,31.3,25.6,58.5c0,95.8-58.5,103.4-113.9,109.7c9.1,7.8,16.9,22.7,16.9,46.1 c0,33.4-0.3,74.8-0.3,83c0,6.5,4.6,14.3,17.2,12c99.3-33,166.5-127.1,166.5-237.2C508.7,120.5,397,16,259.4,16z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGitHub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GitHub.1b15ee888385a7754cf4d726ac4cd39b.svg";